<div class="tt-c-review-flow-footer">
  <p v-for="text in texts" class="tt-c-review-flow-footer__text" v-html="text"></p>
</div>
